export const blockIconsPhotoandimageBlurOnNew = (
	<span className='material-symbols-outlined'>blur_on</span>
);
